import { useEffect, useState } from 'react';

export default function Content(props) {
    const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState(null);

    const _d = {
        slug: props.data.slug,
        title: props.data.title.rendered,
        date: props.data.date,
        content: props.data.content.rendered,
        image: (props.data._embedded && props.data._embedded['wp:featuredmedia']) && props.data._embedded['wp:featuredmedia'][0].source_url,
        videos: props.data.acf?.videos?.split(';'),
        privacyPolicyId: props.data.acf?.altalanos_rendezveny_adatvedelmi_feltetelek_document,
        privacyPolicyLabel: props.data.acf?.rendezveny_adatvedelmi_feltetelek_gomb_felirat,
    };

    useEffect(() => {
        const fetchAttachmentUrl = async () => {
            if (_d.privacyPolicyId && typeof _d.privacyPolicyId === 'number') {
                try {
                    const res = await fetch(global.endpoint + 'wp-json/wp/v2/media/' + _d.privacyPolicyId);
                    const data = await res.json();
                    setPrivacyPolicyUrl(data?.source_url || null);
                } catch (err) {
                    console.error('Hiba a dokumentum letöltésénél:', err);
                }
            }
        };
        fetchAttachmentUrl();
    }, [_d.privacyPolicyId]);

    return (
        <div className='w-full flex flex-col items-center px-site py-8 xl:py-16'>
            <div className='w-full max-w-boxed flex flex-col gap-16'>
                <div className='leading-relaxed content-text text-stone-600' dangerouslySetInnerHTML={{ __html: _d.content }} />

                {(_d.videos && _d.videos.length > 0 && _d.videos[0] !== '') && (
                    <div className='flex-1 flex flex-col lg:flex-row gap-12'>
                        {_d.videos.map((item, index) => (
                            <div key={index} className='flex-1 bg-primary/10 p-3'>
                                <video controls className='w-full shadow-xl'>
                                    <source src={item} type="video/mp4" />
                                </video>
                            </div>
                        ))}
                    </div>
                )}

                {privacyPolicyUrl && (
                    <div className='w-full flex flex-col gap-2 items-center'>
                        <div className='text-xs text-center'>
                            A rendezvényen kép- és hangfelvétel készülhet, amelyet a szervező Siloám Református Missziói Otthon weboldalán, közösségi média felületein és kiadványaiban felhasználhat.
                        </div>
                        <a
                            target='_blank'
                            href={privacyPolicyUrl}
                            className='text-center button-dark-hover'
                            rel='noreferrer'
                        >
                            {_d.privacyPolicyLabel}
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
}